<script lang="ts">
    import { getContext } from 'svelte'
    import { fly, fade } from 'svelte/transition'

    export let comment

    const editComment: (comment) => void = getContext('editComment')
    const removeComment: (comment) => void = getContext('removeComment')

    function handleEdit() {
        editComment(comment)
    }

    function handleRemove() {
        removeComment(comment)
    }

    function formatTimestamp(timestamp) {
        const date = new Date(timestamp * 1000)
        return date.toLocaleString()
    }
</script>

<div class="cm-comment card mt-2" class:border-danger={comment.hasError} class:border-warning={comment.isUnsynced}>
    <div class="card-body" class:text-danger={comment.hasError}>
        <p>
            {@html comment.displaytext}
        </p>
    </div>

    <div class="card-footer p-0 d-flex align-items-center" role="toolbar" aria-label="Kommentar-Aktionen">

        {#if comment.user || comment.timecreated}
        <small in:fade={{ duration: 200 }} class="text-muted p-2">
            {#if comment.timecreated}
                Am <span class="date">{formatTimestamp(comment.timecreated)}</span> von
            {:else}
                Von
            {/if}

            {#if !comment.isOwn && comment.canEdit}
                <a href={`/user/profile.php?id=${comment.user.id}`} class="username">
                    {`${comment.user.firstname} ${comment.user.lastname}`}
                </a>
            {:else}
                <span class="username">
                    {`${comment.user.firstname} ${comment.user.lastname}`}
                </span>
            {/if}
        </small>
        {/if}

        {#if comment.canDelete || comment.canEdit}
        <div class="btn-group ml-auto">

            {#if comment.canDelete}
                <a class="btn btn-link" on:click|preventDefault={handleRemove} data-action="remove" href="#remove">
                    <i class="fa fa-trash"></i>
                </a>
            {/if}

            {#if comment.canEdit}
                <a class="btn btn-link" on:click|preventDefault={handleEdit} data-action="edit" href="#edit">
                    <i class="fa fa-pencil"></i>
                </a>
            {/if}

        </div>
        {/if}
    </div>
</div>
